import { unlockUser } from "../services/ api_services";
import { ToastTypes } from "../context/ToastProvider";
import useLoading from "./useLoading";
import useToast from "./useToast";

const UNLOCK_ERROR_MESSAGES = {
    400: "요청 값이 올바르지 않습니다.",
    403: "잠금 해제 권한이 없습니다.",
    404: "회원 정보를 찾을 수 없습니다.",
    501: "urinalysis 프로필에서만 지원됩니다.",
};

/**
 * 회원 계정 잠금 해제 요청 훅 (회원상세 화면 / 계정상태 다이얼로그 공용)
 * @returns {(userSeq: string) => Promise<boolean>} 해제 성공 여부
 */
function useUnlockUser() {
    const { showToast } = useToast();
    const { setLoading } = useLoading();

    const requestUnlock = async (userSeq) => {
        setLoading(true);
        try {
            const adminSeq = sessionStorage.getItem("adminSeq");
            const adminLevelCd = sessionStorage.getItem("adminLevelCd");
            const response = await unlockUser({ user_seq: userSeq, admin_seq: adminSeq, admin_level_cd: adminLevelCd });
            setLoading(false);

            const resultCode = response?.data?.resultCode;
            if (response && response.status === 200 && resultCode === 200) {
                showToast(ToastTypes.SUCCESS, "성공", "계정 잠금을 해제했습니다.");
                return true;
            }

            const message = response?.data?.resultMsg || UNLOCK_ERROR_MESSAGES[resultCode] || "계정 잠금 해제에 실패했습니다.";
            showToast(ToastTypes.ERROR, "실패", message);
            return false;
        } catch (e) {
            setLoading(false);
            console.log("e===>", e);
            return false;
        }
    };

    return requestUnlock;
}

export default useUnlockUser;
